module.exports = __webpack_public_path__ + "img/card-kynorelle.84ac12ad.webp";